import axios from "axios";

document.getElementById('subscriptionForm').addEventListener('submit', function(event) {
    event.preventDefault(); // Prevent the default form submission

    const emailInput = event.target.querySelector('input[type="email"]');
    const csrfTokenInput = event.target.querySelector('input[name="_csrf_token"]');

    if (!emailInput) {
        alert('Поле email не найдено.');
        return;
    }

    const email = emailInput.value;

    if (!csrfTokenInput) {
        alert('CSRF токен не найден.');
        return;
    }

    const csrfToken = csrfTokenInput.value;

    // Validate email (simple regex for demonstration)
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
        alert('Пожалуйста, введите корректный адрес электронной почты.');
        return;
    }

    // Send data to the server
    axios.post('/subscribe', {
        email: email,
        _csrf_token: csrfToken
    })
        .then(response => {
            alert('Спасибо за подписку на новости!');
            emailInput.value = ''; // Clear the input field after successful submission
        })
        .catch(error => {
            if (error.response && error.response.data && error.response.data.errors) {
                alert(error.response.data.errors);
            } else {
                alert('Произошла ошибка. Пожалуйста, попробуйте снова.');
            }
        });
});
